import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import _ from 'lodash';
import dropsLoader from '@/mixins/components/drops-loader';
import { cognitoMixins } from '@storm/mixins/cognito';
import loadData from '@storm/mixins/load-data';

export default Vue.component('storm-tickets-table', {
  template: require('./template.html'),
  name: 'storm-tickets-table',
  mixins: [cognitoMixins, loadData],
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'allTickets',
      'mappedStormUsers',
      'stormSession',
      'stormUser',
    ]),
    filteredTickets() {
      const sortOn = this.sortKey || this.cols[4];
      const { sub } = this.stormUser;
      let filtered = this.allTickets;
      if (this.filters.mine) {
        filtered = _.filter(this.allTickets, ticket => ticket.assigned === sub);
      }
      const status = _.filter(Object.keys(this.filters.status), k => this.filters.status[k]);
      const priority = _.filter(Object.keys(this.filters.priority), k => this.filters.priority[k]);
      filtered = _.filter(
        filtered, item => status.includes(item.status) && priority.includes(item.priority),
      );
      const synced = _.chain(filtered)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.cols, (c) => {
                  // clean up the values so that the
                  // searchable items are like how
                  // the template is written
                  const col = this.cleanItem(row[c], c, row);
                  e.push(col);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
        })
        .value();
      return synced;
    },
  },
  data() {
    const cols = ['subject', 'status', 'priority', 'assigned', 'updated', 'created'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), -1));
    return {
      gettingTickets: false,
      cols,
      sortMap,
      filterKey: '',
      sortKey: '',
      paginate: ['ticketlist'],
      showFilters: false,
      filters: {
        mine: false,
        status: {
          unassigned: true,
          new: true,
          assigned: false,
          closed: false,
          'in-progress': false,
          'needs-feedback': false,
        },
        priority: {
          high: true,
          low: true,
          normal: true,
        },
      },
    };
  },
  created() {
    this.getFilters();
    this.getStormUsers();
    this.getTickets();
  },
  methods: {
    getFilters() {
      const filters = JSON.parse(window.localStorage.getItem('stormTicketFilters'));
      if (filters) {
        this.$set(this, 'filters', filters);
      }
    },
    setFilters() {
      window.localStorage.setItem('stormTicketFilters', JSON.stringify(_.cloneDeep(this.filters)));
    },
    async getTickets(refresh) {
      if ((this.allTickets.length < 1 && !refresh) || refresh) {
        this.gettingTickets = true;
        try {
          const { data } = await this.stormInvoke({
            data: {
              method: 'getSupportTickets',
            },
          });
          this.$store.dispatch('setAllTickets', data.tickets);
        } catch (e) {
          this.$log.error(e.message || e);
        } finally {
          this.gettingTickets = false;
        }
      }
    },
    openTicket(ticket) {
      this.$emit('set-ticket', ticket);
    },
    onSearch(e) {
      this._debounce(() => {
        this.filterKey = e.target.value;
      }, 250);
    },
    formatTime(stamp) {
      return moment(stamp).format('MM-DD-YYYY hh:mm:ss A');
    },
    getStatusClasses(col, val) {
      const classes = [];
      if (col === 'status') {
        classes.push(
          'adminUi-ticket-status',
          `adminUi-ticket-${val}`,
        );
      }
      if (col === 'priority') {
        classes.push(
          'adminUi-ticket-priority',
          `adminUi-ticket-${val}`,
        );
      }
      return classes;
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (['created', 'updated'].includes(col)) {
        i = this.formatTime(item);
      }
      if (['priority', 'status'].includes(col)) {
        i = this._startCase(i);
      }
      if (col === 'assigned' && item && this.mappedStormUsers[item]) {
        i = this.mappedStormUsers[item].name;
      }
      return i;
    },
    highlight(ctx, query, col) {
      const c = this.cleanItem(ctx, col);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/tickets/table/index.js